import { inject, Injectable } from '@angular/core';
import { Timestamp } from '@firebase/firestore';
import { PublicEventLog } from './public-event-logs-collection.models';
import { FirestoreService } from '../../firestore.service';
import { FIRESTORE_COLLECTIONS } from '../../firestore.constants';

@Injectable({
  providedIn: 'root',
})
export class PublicEventLogsCollectionService {
  private readonly _firestoreService = inject(FirestoreService);

  public async getPublicEventLogsByDateRange(
    startDate: Date,
    endDate: Date,
  ): Promise<PublicEventLog[]> {
    return this._firestoreService.getDocuments<PublicEventLog>({
      collectionName: FIRESTORE_COLLECTIONS.PUBLIC_EVENT_LOGS,
      filters: [
        { field: 'dateTimeLogged', operator: '>=', value: Timestamp.fromDate(startDate) },
        { field: 'dateTimeLogged', operator: '<=', value: Timestamp.fromDate(endDate) },
      ],
      order: [{ field: 'dateTimeLogged', direction: 'asc' }],
    });
  }
}
